import React from "react";
import { Link } from "react-router-dom";
import { useContentInfo, DEFAULT_CONTENT_INFO } from "../contexts/ContentContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPhone, faEnvelope, faMapMarkerAlt } from "@fortawesome/free-solid-svg-icons";

function Footer() {
  const { contentInfo } = useContentInfo();
  const contact = contentInfo?.contact || DEFAULT_CONTENT_INFO.contact;
  const footerLogoURL = contentInfo?.footerLogoURL || DEFAULT_CONTENT_INFO.footerLogoURL;

  return (
    <footer className="main-footer">
      <div className="footer-container">
        {/* Brand Info */}
        <div className="footer-column brand-info">
          <div className="footer-logo">
            <img src={footerLogoURL} alt="Health Care Logo" />
          </div>
          <p>
            Dawaa Pharmacy is your trusted online pharmacy, delivering 100% genuine medicines right to your doorstep. We are committed to providing high-quality healthcare products, ensuring convenience, affordability, and reliability. Shop with confidence and experience hassle-free medicine delivery from the comfort of your home.
          </p>
        </div>

        {/* Company Links */}
        <div className="footer-column">
          <h3>Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About</Link></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><Link to="/categories">Categories</Link></li>
          </ul>
        </div>

        {/* Support Links */}
        <div className="footer-column">
          <h3>Support</h3>
          <ul>
            <li><Link to="/responsibilities">Responsibilities</Link></li>
            <li><Link to="/faq">FAQ</Link></li>
          </ul>
        </div>

        {/* Contact & Social */}
        <div className="footer-column contact-social">
          <h3>Contact Us</h3>
          <p className="footer-contact-row">
            <span className="footer-contact-icon footer-contact-icon--phone">
              <FontAwesomeIcon icon={faPhone} />
            </span>
            <a href={`tel:${contact.phoneNumber}`} className="footer-contact-link">{contact.phoneNumber}</a>
          </p>
          <p className="footer-contact-row">
            <span className="footer-contact-icon footer-contact-icon--whatsapp">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="13" height="13">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
              </svg>
            </span>
            <a
              href={`https://wa.me/${contact.whatsappNumber.replace(/\D/g, "")}`}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-link"
            >{contact.whatsappNumber}</a>
          </p>
          <p className="footer-contact-row">
            <span className="footer-contact-icon footer-contact-icon--email">
              <FontAwesomeIcon icon={faEnvelope} />
            </span>
            <a
              href={`https://mail.google.com/mail/?view=cm&to=${contact.email}`}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-contact-link"
            >{contact.email}</a>
          </p>
          <span className="footer-contact-row footer-address">
            <span className="footer-contact-icon footer-contact-icon--email">
              <FontAwesomeIcon icon={faMapMarkerAlt} />
            </span>
            {contact.location}
          </span>

          <h3>Social Media</h3>
          <div className="social-icons">
            {/* Instagram */}
            <Link to="https://www.instagram.com/dawaacare/" target="_blank" className="social-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ height: "100%", width: "100%" }}
              >
                <g>
                  <path d="M12,2.162c3.204,0,3.584,0.012,4.849,0.07c1.308,0.06,2.655,0.358,3.608,1.311c0.962,0.962,1.251,2.296,1.311,3.608c0.058,1.265,0.07,1.645,0.07,4.849c0,3.204-0.012,3.584-0.07,4.849c-0.059,1.301-0.364,2.661-1.311,3.608c-0.962,0.962-2.295,1.251-3.608,1.311c-1.265,0.058-1.645,0.07-4.849,0.07s-3.584-0.012-4.849-0.07c-1.291-0.059-2.669-0.371-3.608-1.311c-0.957-0.957-1.251-2.304-1.311-3.608c-0.058-1.265-0.07-1.645-0.07-4.849c0-3.204,0.012-3.584,0.07-4.849c0.059-1.296,0.367-2.664,1.311-3.608c0.96-0.96,2.299-1.251,3.608-1.311C8.416,2.174,8.796,2.162,12,2.162 M12,0C8.741,0,8.332,0.014,7.052,0.072C5.197,0.157,3.355,0.673,2.014,2.014C0.668,3.36,0.157,5.198,0.072,7.052C0.014,8.332,0,8.741,0,12c0,3.259,0.014,3.668,0.072,4.948c0.085,1.853,0.603,3.7,1.942,5.038c1.345,1.345,3.186,1.857,5.038,1.942C8.332,23.986,8.741,24,12,24c3.259,0,3.668-0.014,4.948-0.072c1.854-0.085,3.698-0.602,5.038-1.942c1.347-1.347,1.857-3.184,1.942-5.038C23.986,15.668,24,15.259,24,12c0-3.259-0.014-3.668-0.072-4.948c-0.085-1.855-0.602-3.698-1.942-5.038c-1.343-1.343-3.189-1.858-5.038-1.942C15.668,0.014,15.259,0,12,0z" />
                  <path d="M12,5.838c-3.403,0-6.162,2.759-6.162,6.162c0,3.403,2.759,6.162,6.162,6.162s6.162-2.759,6.162-6.162C18.162,8.597,15.403,5.838,12,5.838z M12,16c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S14.209,16,12,16z" />
                  <circle cx="18.406" cy="5.594" r="1.44" />
                </g>
              </svg>
            </Link>

            {/* Facebook */}
            <Link to="https://www.facebook.com/dawaacare.pk" target="_blank" className="social-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                style={{ height: "100%", width: "100%" }}
              >
                <g>
                  <path d="M24,12.073c0,5.989-4.394,10.954-10.13,11.855v-8.363h2.789l0.531-3.46H13.87V9.86c0-0.947,0.464-1.869,1.95-1.869h1.509V5.045c0,0-1.37-0.234-2.679-0.234c-2.734,0-4.52,1.657-4.52,4.656v2.637H7.091v3.46h3.039v8.363C4.395,23.025,0,18.061,0,12.073c0-6.627,5.373-12,12-12S24,5.445,24,12.073z" />
                </g>
              </svg>
            </Link>

            {/* Admin */}
            <Link to="/admin" className="social-box">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                style={{
                  borderRadius: "50%",
                  color: "#c90f2f",
                  background: "white"
                }}
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M9.175 10.825Q8 9.65 8 8t1.175-2.825T12 4t2.825 1.175T16 8t-1.175 2.825T12 12t-2.825-1.175M4 20v-2.8q0-.85.438-1.562T5.6 14.55q1.55-.775 3.15-1.162T12 13t3.25.388t3.15 1.162q.725.375 1.163 1.088T20 17.2V20z"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <p>© dawaacare.com. All rights reserved</p>
        <div className="footer-legal">
          <Link to="/">Terms & Conditions</Link>
          <Link to="/">Privacy Policy</Link>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
